module.exports = __webpack_public_path__ + "img/car-icon.ccc656db.svg";